import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isActivitiesOpen, setIsActivitiesOpen] = useState(false);

  return (
    <nav className="bg-primary text-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="text-2xl font-bold">
              <span className="text-white">Leftley</span>
              <span className="text-secondary"> Sports Club</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="hover:text-secondary transition duration-300 font-medium">
              Home
            </Link>
            
            {/* Activities Dropdown */}
            <div 
              className="relative group"
              onMouseEnter={() => setIsActivitiesOpen(true)}
              onMouseLeave={() => setIsActivitiesOpen(false)}
            >
              <button className="hover:text-secondary transition duration-300 font-medium flex items-center">
                Activities
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {isActivitiesOpen && (
                <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-xl py-2 z-50">
                  <Link to="/activities" className="block px-4 py-2 text-gray-800 hover:bg-primary hover:text-white transition duration-200 font-semibold border-b border-gray-200">
                    All Activities
                  </Link>
                  <Link to="/activities/football" className="block px-4 py-2 text-gray-800 hover:bg-primary hover:text-white transition duration-200">
                    Football
                  </Link>
                  <Link to="/activities/walk-and-talk" className="block px-4 py-2 text-gray-800 hover:bg-primary hover:text-white transition duration-200">
                    Walk & Talk
                  </Link>
                  <Link to="/activities/womens-coffee-mornings" className="block px-4 py-2 text-gray-800 hover:bg-primary hover:text-white transition duration-200">
                    Women's Coffee Mornings
                  </Link>
                  <Link to="/activities/womens-aerobics" className="block px-4 py-2 text-gray-800 hover:bg-primary hover:text-white transition duration-200">
                    Women's Aerobics
                  </Link>
                  <Link to="/activities/cycling" className="block px-4 py-2 text-gray-800 hover:bg-primary hover:text-white transition duration-200">
                    Cycling
                  </Link>
                </div>
              )}
            </div>

            <Link to="/community-hub" className="hover:text-secondary transition duration-300 font-medium">
              Community Hub
            </Link>
            <Link to="/minibus-booking" className="hover:text-secondary transition duration-300 font-medium">
              🚌 Minibus Booking
            </Link>
            <Link to="/membership" className="hover:text-secondary transition duration-300 font-medium">
              Membership
            </Link>
            <Link to="/membership" className="btn-secondary">
              Join Now
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-primary-dark transition duration-300"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-primary-dark">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link to="/" className="block px-3 py-2 rounded-md hover:bg-primary transition duration-300">
              Home
            </Link>
            <div className="px-3 py-2">
              <button 
                onClick={() => setIsActivitiesOpen(!isActivitiesOpen)}
                className="flex items-center justify-between w-full hover:text-secondary transition duration-300"
              >
                <span>Activities</span>
                <svg className={`w-4 h-4 transition-transform ${isActivitiesOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isActivitiesOpen && (
                <div className="mt-2 pl-4 space-y-2">
                  <Link to="/activities" className="block py-1 text-sm font-semibold hover:text-secondary transition duration-300">
                    All Activities
                  </Link>
                  <Link to="/activities/football" className="block py-1 text-sm hover:text-secondary transition duration-300">
                    Football
                  </Link>
                  <Link to="/activities/walk-and-talk" className="block py-1 text-sm hover:text-secondary transition duration-300">
                    Walk & Talk
                  </Link>
                  <Link to="/activities/womens-coffee-mornings" className="block py-1 text-sm hover:text-secondary transition duration-300">
                    Women's Coffee Mornings
                  </Link>
                  <Link to="/activities/womens-aerobics" className="block py-1 text-sm hover:text-secondary transition duration-300">
                    Women's Aerobics
                  </Link>
                  <Link to="/activities/cycling" className="block py-1 text-sm hover:text-secondary transition duration-300">
                    Cycling
                  </Link>
                </div>
              )}
            </div>
            <Link to="/community-hub" className="block px-3 py-2 rounded-md hover:bg-primary transition duration-300">
              Community Hub
            </Link>
            <Link to="/minibus-booking" className="block px-3 py-2 rounded-md hover:bg-primary transition duration-300">
              🚌 Minibus Booking
            </Link>
            <Link to="/membership" className="block px-3 py-2 rounded-md hover:bg-primary transition duration-300">
              Membership
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
